import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from '@angular/core';

/** Ajuste le tableau entier à l'espace disponible, sans retirer de livrables. */
@Directive({ selector: '[appCiuFit]', standalone: true })
export class CiuFitDirective implements AfterViewInit, OnDestroy {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private observer?: ResizeObserver;

  ngAfterViewInit(): void {
    const content = this.host.firstElementChild as HTMLElement | null;
    if (!content) return;

    this.observer = new ResizeObserver(() => {
      // Les dimensions de mise en page ne changent pas avec transform :
      // observer le contenu permet aussi de réagir au chargement des données.
      const scale = Math.min(1,
        this.host.clientWidth / Math.max(1, content.offsetWidth),
        this.host.clientHeight / Math.max(1, content.offsetHeight));
      content.style.setProperty('--ciu-scale', String(scale));
    });
    this.observer.observe(this.host);
    this.observer.observe(content);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
